import axios from 'axios'
import { stripTrailingSlash } from 'loans/services/utils'

export function useLoansClient() {
  const config = useRuntimeConfig()
  const loansApiUrl = stripTrailingSlash(config.public.loanApi)

  return axios.create({
    baseURL: loansApiUrl,
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'json',
  })
}
